{
  "colorSwatchPicker": "Fargekart",
  "dropzoneLabel": "Droppsone",
  "selectPlaceholder": "Velg et element",
  "tableResizer": "Størrelsesendrer"
}
